import { TextArea } from '@nike/eds'
import { HTMLAttributes } from 'react'
import './MultilineSearchInput.css'

export interface MultilineInputProps extends HTMLAttributes<HTMLTextAreaElement> {
  name: string
  label: string
  value?: any
}

export function MultilineSearchInput({
  name,
  label,
  value = '',
  ...otherProps
}: MultilineInputProps) {
  return (
    <div className="multiline-searchinput">
      <label className="search-label">{label}</label>
      <TextArea
        id={`${name}Input`}
        value={value}
        label={label}
        hideLabel={true}
        name={name}
        resize="vertical"
        style={{ padding: 'var(--eds-space-4)' }}
        {...otherProps}
      />
    </div>
  )
}
